import { render, staticRenderFns } from "./btn-language-prop.vue?vue&type=template&id=56a42cdb&scoped=true"
import script from "./btn-language-prop.vue?vue&type=script&lang=js"
export * from "./btn-language-prop.vue?vue&type=script&lang=js"
import style0 from "./btn-language-prop.vue?vue&type=style&index=0&id=56a42cdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a42cdb",
  null
  
)

export default component.exports